import "./src/assets/scss/main.scss";

export const onClientEntry = () => {
  if (typeof document !== "undefined" && document.documentElement && !document.documentElement.hasAttribute("lang")) {
    document.documentElement.setAttribute("lang", "en");
  }
};
